<template>
  <NuxtLayout
    :name="layoutName"
    :navbar-color="layoutNavbarColor"
    :footer-color="layoutFooterColor"
    :layoutButtonText="layoutButtonText"
  >
    <div class="survey-page">
      <div v-if="story" class="survey-page__container">
        <header class="survey-page__header">
          <img
            src="/images/svg/infermedica-logo-dark.svg"
            alt="Infermedica logo"
            class="survey-page__logo"
          />
        </header>
        <main class="survey-page__main">
          <Transition name="fade">
            <div v-if="isLoading" class="survey-page__loading-overlay">
              <LoaderSpinner cobalt />
            </div>
          </Transition>
          <StepperFormSatisfactionSurvey v-if="!isLoading" />
        </main>
        <footer class="survey-page__footer">
          <div class="survey-page__footer-content">
            <span class="survey-page__powered-by"
              >Powered by Infermedica Inc.</span
            ><br />
            <a
              href="https://contact.infermedica.com/hubfs/customer-support/Personal%20Data%20Information%20Clause%20NPS%20ENG.pdf?__hstc=251652889.4737c27b60e95ca72d72102b38daa7f9.1718617093965.1718697952030.1718780210757.6&__hssc=251652889.1.1718780210757&__hsfp=221870567"
              target="_blank"
            >
              Information Clause for Clients
            </a>
          </div>
        </footer>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
const route = useRoute()
const queryParams = route.query
const isLoading = ref(true)

onMounted(() => {
  if (!queryParams.email) {
    throw createError({
      message: 'Email query parameter is required',
      statusCode: 404,
      fatal: true,
    })
  }

  isLoading.value = false
})

definePageMeta({
  layout: 'blank',
})
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})
const { story } = await useFetchStory('implementation-satisfaction-survey')

const { layoutName, layoutNavbarColor, layoutButtonText, layoutFooterColor } =
  useStoryLayout<any>(story)
useCustomHead(story)
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.survey-page {
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  background-color: var(--paper-100);
  padding: 48px 0;
  display: flex;
  flex-direction: column;

  &__container {
    width: 100%;
    padding: 0 20px;
    margin: 0 auto;
    height: 100%;
    flex: 1;
    align-self: stretch;
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-md) {
      max-width: 552px;
      padding: 0 40px;
    }

    @media (min-width: $breakpoint-lg) {
      max-width: 738px;
    }
  }

  &__logo {
    width: 120px;
    height: auto;
  }

  &__header {
    display: flex;
    justify-content: center;
    margin-bottom: 54px;
  }

  &__main {
    position: relative;
    height: 100%;
    margin-bottom: 80px;
  }

  &__loading-overlay {
    background-color: var(--paper-100);
    z-index: 1;
    width: 100%;
    height: 50vh;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__footer {
    font-size: var(--font-size-paragraph-xs);
    line-height: 24px;
    text-align: center;
    width: 100%;
    margin-top: auto;
  }

  &__powered-by {
    color: var(--paper-500);
  }
}
</style>
